import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventEmitter } from 'events';
import { CommonService } from '../../services/sagstudioService/common.service';
import { ToastService } from '../../services/sagstudioService/sagtoast.service';
import { TranslateService } from '../../services/sagstudioService/translate.service';
import { ThemeOptionsService } from './theme-options.service';
import { backgrounds, generalTheme } from './theme.const';
declare function success(msg);

@Component({
  selector: 'app-themes',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.scss']
})
export class ThemesComponent implements OnInit {


  selectedThemeIndex: number = 0;
  selectedTheme_id: string = "1";      // theme_id
  themeColorScheme: string = "1.1";      // color_scheme
  selectedColorScheme: any = [];      // color scheme(s) according to selected theme
  rightside_variables: any = [];        // this.themeObj[this.selectedThemeIndex].theme_data;

  generalTheme = generalTheme;
  bgs = backgrounds;
  selectedBackground: string = 'Default';
  menuPosition: string = '1';
  subsetting: string = '';
  toggle: boolean = false;
  propertyVal = {};
  themeColors: {};
  themeIcons: {};
  selectedTheme: string = 'Default';
  id: string;
  name: string;
  userId: string;
  sagClientId: string;

  constructor(private _router: Router,
    private _http: HttpClient,
    public translate: TranslateService,
    public common: CommonService,
    public _toast: ToastService,
    private _formBuilder: FormBuilder,
    private activeRoute: ActivatedRoute,
    public themeService: ThemeOptionsService,

  ) {
    this.rightside_variables = themeService.rightside_variables;
    this.selectedTheme_id = themeService.selectedTheme_id;
    this.themeColorScheme = themeService.themeColorScheme;
    this.selectedThemeIndex = themeService.selectedThemeIndex;
    this.selectedColorScheme = themeService.selectedColorScheme;
    this.menuPosition = themeService.menuPosition;
  }

  ngOnInit() {
    this.themeService.themeChange('0');
  }
  @Output() setId = new EventEmitter();

  close(): void {
    this.setId.emit(null);
  }

  /** TO CHANGE VALUE OF CSS VARIABLE I THEME */
  changeColor(value: any, propName: string) {
    // const [r, g, b] = value.match(/\w\w/g).map((x) => parseInt(x, 16));
    // const _val = [r, g, b].toString(); 
    const _val = value.match(/\((.+)\)/)[1].toString()
    const el: HTMLElement = document.querySelector("app-root");
    el.style.setProperty("--" + propName, _val);

    if (propName == 'topMenuTxtClr') {
      let topList = document.querySelectorAll<HTMLElement>("#top_nav_bar .navbar-nav li a#navbarDropdown");
      Array.from(topList).forEach((element) => {
        element.style.setProperty("color", "rgba(var(--topMenuTxtClr))", "important");
      });
    }
  }

  dashFlag = '1';
  changeDashboard(ev: any): void {
    let flag = (ev == '1') ? false : true;
    this.dashFlag = ev;
    // this.shareService.setData("dashFlag", flag);
    this.themeService.setDash(flag);
  }

  toggleMenu(menu: string): void {
    if (this.toggle == true && this.subsetting != '' && this.subsetting != menu) {
      this.toggle = false;
    }
    this.subsetting = menu;
    this.toggle = !this.toggle;
  }

  iconBehaviorHandler(elem: any, ev: any, propName: any) {
    const _value = ev.target.value;
    elem['--' + 'value'] = _value;
    const el: HTMLElement = document.querySelector("#mainComp");
    // const _val : string = _value.replace(/rgba\(|\)/g, '');
    el.style.setProperty("--" + propName, _value);
  }


  getCssProperties() {
    if (confirm('Are you sure you want to Save Current Changes.?')) {
      this.propertyVal = {};
      this.themeColors = {};
      this.themeIcons = {};
      this.propertyVal["selectedTheme"] = this.selectedTheme;
      this.propertyVal["selectedBackground"] = this.selectedBackground;
      this.propertyVal["themeColorScheme"] = this.themeService.themeColorScheme;
      this.propertyVal["menuPosition"] = this.themeService.menuPosition;
      this.propertyVal["selectedDashboard"] = this.dashFlag;
      this.propertyVal["themeColors"] = this.themeColors;
      this.propertyVal["themeIcons"] = this.themeIcons;
      this.id = this.themeService.id;
      this.name = this.themeService.name;
      this.userId = this.themeService.userId;
      this.sagClientId = this.themeService.sagClientId;

      // var returnedTarget: any;
      // update color by right side form input colors.
      for (let i of this.rightside_variables) {
        for (let a of i.section_fields) {
          if (a.inputType == 'color') {
            this.themeColors['--' + a.name] = a['--value'];
          } else if (a.inputType == 'selectOption') {
            this.themeIcons['--' + a.name] = a['--value']; // "none"; 
          }
        }
      }

      // this.themeColors['--topMenuIcon'] = "none";

      // console.log(this.propertyVal);
      var stringify_data = JSON.stringify(this.propertyVal);

      let reqObj = {
        "id": (this.id) ? this.id : '',
        'name': (this.name) ? this.name : '',
        'menuPos': '',
        'dTemplate': this.dashFlag,
        'json': stringify_data,
        'userId': (this.userId) ? this.userId : '',
        'sagClientId': (this.sagClientId) ? this.sagClientId : '',
        'flag': ''
      };
      // console.log("+++     Saved Color Theme Object     +++");
      // console.log(reqObj);
      this.themeService.postDataDirectBaseUrl('theme/updateUserThemeJson', reqObj).subscribe(res => {
        if (res) {
          this.updateProperties();
          success(res['msg']);
        }

      })
    }
  }

  setDefaultSCSSPropsHandler() {
    // console.log("--------------- SET DEFAULT SCSS [LIKE > a7-default.css] --------------");
    // debugger
    if (confirm('Are you sure you want to set Default color Theme?')) {
      this.propertyVal = {};
      this.themeColors = {};
      this.propertyVal["selectedTheme"] = this.selectedTheme;
      this.propertyVal["selectedBackground"] = this.selectedBackground;
      this.propertyVal["themeColorScheme"] = "1.1"; // this.themeColorScheme;
      this.propertyVal["menuPosition"] = this.menuPosition;
      this.propertyVal["selectedDashboard"] = this.dashFlag;
      // this.propertyVal["allColorSchemes"] = this.allColorSchemes;
      this.propertyVal["themeColors"] = []; // this.themeColors;
      this.propertyVal["themeIcons"] = []; // this.themeIcons;
      this.id = this.themeService.id;
      this.name = this.themeService.name;
      this.userId = this.themeService.userId;
      this.sagClientId = this.themeService.sagClientId;


      // returnedTarget = Object.assign(target, this.propertyVal);
      // var stringify_data = JSON.stringify(returnedTarget);
      var stringify_data = JSON.stringify(this.propertyVal);
      // console.log(stringify_data);
      // debugger;
      let reqObj = {
        "id": (this.id) ? this.id : '',
        'name': (this.name) ? this.name : '',
        'menuPos': '',
        'dTemplate': this.dashFlag,
        'json': stringify_data,
        'userId': (this.userId) ? this.userId : '',
        'sagClientId': (this.sagClientId) ? this.sagClientId : '',
        'flag': ''
      };

      this.themeService.postDataDirectBaseUrl('theme/updateUserThemeJson', reqObj).subscribe(res => {
        if (res) {
          // console.log(res);
        }
      })
    }
    this.updateProperties();
  }

  resetSCSSPropsHandler() {
    if (confirm('Are you sure you want to reset current Changes?')) {
      this.updateProperties();
    }
  }
  updateProperties() {
    const props = this.propertyVal;
    this.themeService.getThemeOptionJSON();
    // this.menuPosition = (this.themeService.propertyVal['menuPosition'])? this.themeService.propertyVal['menuPosition'] : '1';
    // this.selectedBackground = (this.themeService.propertyVal['selectedBackground']) ? this.themeService.propertyVal['selectedBackground'] : 'Default';
    // this.themeColorScheme = (this.themeService.propertyVal['themeColorScheme']) ? this.themeService.propertyVal['themeColorScheme'] : "1.1";
    // this.dashFlag = (this.themeService.propertyVal['selectedDashboard']) ? this.themeService.propertyVal['selectedDashboard'] : '1';
    // this.selectedTheme = (this.themeService.propertyVal['selectedTheme']) ? this.themeService.propertyVal['selectedTheme'] : 'Default';
    this.menuPosition = (props['menuPosition']) ? props['menuPosition'] : this.themeService.propertyVal['menuPosition'];
    this.selectedBackground = (props['selectedBackground']) ? props['selectedBackground'] : this.themeService.propertyVal['selectedBackground'];
    this.themeColorScheme = (props['themeColorScheme']) ? props['themeColorScheme'] : this.themeService.propertyVal['themeColorScheme'];
    this.dashFlag = (props['selectedDashboard']) ? props['selectedDashboard'] : this.themeService.propertyVal['selectedDashboard'];
    this.selectedTheme = (props['selectedTheme']) ? props['selectedTheme'] : this.themeService.propertyVal['selectedTheme'];
    this.selectedThemeIndex = (this.themeService.selectedThemeIndex) ? this.themeService.selectedThemeIndex : 0;
  }


  leftPos: boolean = false;
  settingPannel() {
    this.leftPos = !this.leftPos;

  }

}
